module.exports = __webpack_public_path__ + "static/media/phone.64b5aab9.svg";